import { render, staticRenderFns } from "./LoaPage4.vue?vue&type=template&id=c43f4818&"
import script from "./LoaPage4.vue?vue&type=script&lang=js&"
export * from "./LoaPage4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports